import React from 'react';
import styles from './LandingPage.module.scss';

export const SolutionSection: React.FC = () => {
  return (
    <section className={styles.solutionSection}>
      <h2 className={styles.headline}>The Solution: Visual Predictability</h2>
      <p className={styles.subheadline}>
        MyMinu bridges the gap between your schedule and their understanding.
      </p>

      <div className={styles.featureGrid}>
        <div className={styles.featureCard}>
          <h4>
            <span style={{ fontSize: '32px' }}>🍕</span> 
            The Visual Wedge
          </h4>
          <p>
            Don't just say it, show it. The colored wedge shrinks as time passes, 
            making the concept of "how long is left" concrete and tangible. 
            No more surprises.
          </p>
        </div>

        <div className={styles.featureCard}>
          <h4>
            <span style={{ fontSize: '32px' }}>🗓️</span> 
            Routine = Safety
          </h4>
          <p>
            Predictability reduces anxiety. When a child knows "Shoes come after Breakfast" 
            via a visual sequence, they feel safe, in control, and eager to take the next step.
          </p>
        </div>

        <div className={styles.featureCard}>
          <h4>
            <span style={{ fontSize: '32px' }}>🏆</span> 
            Gamified Focus
          </h4>
          <p>
            Turn transitions into a game. "Can you beat the timer?" shifts the dynamic 
            from parental nagging to a fun challenge they want to win.
          </p>
        </div>

        <div className={styles.featureCard}>
          <h4>
            <span style={{ fontSize: '32px' }}>🧠</span> 
            Builds Independence
          </h4>
          <p>
            Over time, the visual cues help children internalize the routine. 
            They start moving to the next task on their own, without you having to ask ten times.
          </p>
        </div>
      </div>
    </section>
  );
};
